import $ from 'jquery';

export const hideSpinner = () => {
  $('.app-spinner').fadeOut();
};
